import { connect } from 'react-redux';
import BillingInfoPage from 'pages/BillingInfoPageNew';
import billingActions from 'store/billing/actions';
import newOlsActions from 'store/newOls/actions';
import Actions from 'store/signUp/actions';
import AuthActions from 'store/auth/actions';

const mapStateToProps = state => {
  return {
    profileDetails: state?.auth?.profile,
    profileDetailsLoading: state?.auth?.isRequesting,
    primaryCard: state.billing.primaryCardDetails,
    primaryCardLoading: state.billing.isRequesting,
    billingUrl: state.billing.newOlsbilling,
    ispaymentLoading: state.billing.ispaymentLoading,
    isPaymentSuccess: state.billing.isPaymentSuccess,
    paymentDetails: state.billing.paymentDetails,
    updatedCardDetails: state.signUp.editedCreditCardInfo,
    updatedCardLoading: state.signUp.creditCardLoading,
    isPrimaryCardFailed: state.billing.isPrimaryCardFailed,
    isAddCardLoading: state.billing.isCardLoading,
    newCardInfo: state.billing.creditCardInfo,
  };
};
const mapDispatchToProps = {
  loadPrimaryCard: billingActions.Creators.loadPrimaryCardRequest,
  loadBillingUrl: billingActions.Creators.loadNewOlsBillingRequest,
  editExistingCreditCard: Actions.Creators.editExistingCreditCardRequest,
  makePayment: billingActions.Creators.makePaymentRequest,
  loadProfile: AuthActions.Creators.loadProfileRequest,
  paymentReset: billingActions.Creators.paymentReset,
  saveCreditCardInfo: billingActions.Creators.addCreditCardRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(BillingInfoPage);
